(function () {
  'use strict';

  angular.module('back.forward.navi', []);
})();
